/* Plantilla AimTrack — acordeones, galeria y carruseles.
   Todo se re-engancha al recargar una seccion en el editor, y cada elemento se marca
   al atarlo para no atar dos veces el mismo escuchador. */
(function () {
  'use strict';

  /* ---- acordeon: solo uno abierto por grupo ---- */
  function acordeones(raiz) {
    raiz.querySelectorAll('[data-vc-grupo="uno"]').forEach(function (grupo) {
      grupo.querySelectorAll('details').forEach(function (det) {
        if (det.dataset.vcAtado === '1') return;
        det.dataset.vcAtado = '1';
        det.addEventListener('toggle', function () {
          if (!det.open) return;
          grupo.querySelectorAll('details').forEach(function (otro) {
            if (otro !== det) otro.open = false;
          });
        });
      });
    });
  }

  /* ---- carruseles: la flecha solo se ensena si el carril desborda de verdad ---- */
  function repasaFlechas(raiz) {
    (raiz || document).querySelectorAll('[data-vc-fl]').forEach(function (btn) {
      var carril = document.getElementById(btn.dataset.vcObj);
      if (!carril) { btn.hidden = true; return; }
      btn.hidden = carril.scrollWidth <= carril.clientWidth + 4;
    });
  }

  function carruseles(raiz) {
    raiz.querySelectorAll('[data-vc-fl]').forEach(function (btn) {
      if (btn.dataset.vcAtado === '1') return;
      btn.dataset.vcAtado = '1';
      btn.addEventListener('click', function () {
        var carril = document.getElementById(btn.dataset.vcObj);
        if (!carril) return;
        var paso = carril.clientWidth * 0.8;
        carril.scrollBy({ left: btn.dataset.vcFl === 'next' ? paso : -paso, behavior: 'smooth' });
      });
    });
    repasaFlechas(raiz);
  }

  /* ---- galeria: miniaturas, flechas y deslizar con el dedo ---- */
  function galerias(raiz) {
    raiz.querySelectorAll('[data-vc-galeria]').forEach(function (gal) {
      if (gal.dataset.vcAtado === '1') return;
      gal.dataset.vcAtado = '1';

      var vistas = Array.prototype.slice.call(gal.querySelectorAll('.vc-gal__vis'));
      var tiras = Array.prototype.slice.call(gal.querySelectorAll('.vc-gal__tira'));
      if (vistas.length === 0) return;
      var i = 0;

      function muestra(n) {
        i = (n + vistas.length) % vistas.length;
        vistas.forEach(function (v, k) { v.classList.toggle('esta', k === i); });
        tiras.forEach(function (t, k) {
          var activa = k === i;
          t.setAttribute('aria-current', activa ? 'true' : 'false');
          if (activa && t.scrollIntoView) {
            t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          }
        });
      }

      tiras.forEach(function (t, k) {
        t.addEventListener('click', function () { muestra(k); });
      });
      gal.querySelectorAll('[data-vc-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          muestra(i + (b.dataset.vcDir === 'next' ? 1 : -1));
        });
      });

      var marco = gal.querySelector('.vc-gal__marco');
      if (marco) {
        var x0 = 0, y0 = 0;
        marco.addEventListener('touchstart', function (e) {
          x0 = e.changedTouches[0].clientX;
          y0 = e.changedTouches[0].clientY;
        }, { passive: true });
        marco.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          /* recorrido minimo y claramente horizontal, o le robamos el scroll a la pagina */
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          muestra(i + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      muestra(0);
    });
  }

  function arranca(raiz) {
    var r = raiz || document;
    acordeones(r);
    carruseles(r);
    galerias(r);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arranca(document); });
  } else {
    arranca(document);
  }

  /* setTimeout y no requestAnimationFrame: un frame puede no llegar nunca
     (pestana en segundo plano) y el repaso se quedaria clavado para siempre */
  var pendiente = null;
  addEventListener('resize', function () {
    clearTimeout(pendiente);
    pendiente = setTimeout(function () { repasaFlechas(document); }, 120);
  });
  addEventListener('load', function () { repasaFlechas(document); });

  document.addEventListener('shopify:section:load', function (e) {
    arranca(e.target);
    repasaFlechas(document);
  });
  document.addEventListener('shopify:section:unload', function () {
    repasaFlechas(document);
  });
})();
